import { addInterestAction } from "@/modules/lead-page/api/lead-page.v2.api";
import {
  AddInterestActionInput,
  InterestAction,
} from "@/modules/lead-page/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export default function useAddInterestAction() {
  const queryClient = useQueryClient();

  const mutationAddInterestAction = useMutation<
    AxiosResponse<InterestAction>,
    { response?: { data?: { message?: string } } },
    { data: AddInterestActionInput }
  >((data) => addInterestAction(data), {
    onSuccess: (_, { data }) => {
      queryClient.invalidateQueries({ queryKey: ["interests"] });
      queryClient.invalidateQueries({
        queryKey: ["interest-actions", [data.interestUid]],
      });
      queryClient.invalidateQueries({
        queryKey: ["interest-action-types", data.interestUid],
      });
    },
  });

  return mutationAddInterestAction;
}
